import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Button, Modal, message } from "antd";
import { useNavigate } from "react-router-dom";

import "./listing.css";

import { HoldersConcentration } from "../../Components/AssetInsight/HoldersConcentration";
import { AssetsLists } from "../../Components/AssetInsight/AssetsList";
import { RealVolume } from "../../Components/AssetInsight/RealVolume";
import { Regulation } from "../../Components/AssetInsight/Regulation";
import { Maturity } from "../../Components/AssetInsight/Maturity";
import { Security } from "../../Components/AssetInsight/Security";
import { General } from "../../Components/AssetInsight/General";
import { ListingAction } from "../../Components";

export const Listing = () => {
  const [open, setOpen] = useState(false);
  const [assetId, setAssetId] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const onSubmitTab = (tab) => {
    setActiveTab(tab);
  };

  const created = useSelector((state) => state.ListingAssetsReducer.created);
  const creating = useSelector((state) => state.ListingAssetsReducer.creating);
  const updating = useSelector((state) => state.ListingAssetsReducer.updating);
  const submitting = creating || updating;
  useEffect(() => {
    if (created) {
      setOpen(false);
      success("The asset has been successfully added.");
      onSubmitTab(0);
    }
  }, [created]);
  return (
    <div className="tabs_container">
      {contextHolder}
      <div className="assets_nav">
        <Button
          onClick={() => {
            setOpen(true);
            setAssetId(null);
          }}
          className="add_assets"
        >
          Create Asset
        </Button>
        <Button
          className="add_assets"
          onClick={() => {
            onSubmitTab(0);
          }}
        >
          Assets List
        </Button>
      </div>
      <Modal
        title={`${!assetId ? "Create Asset" : "Update Asset"}`}
        width={700}
        visible={open}
        setVisible={setOpen}
        closable={!submitting}
        maskClosable={!submitting}
        keyboard={!submitting}
        onCancel={() => {
          if (submitting) return;
          setOpen(false);
        }}
        footer={false}
        destroyOnClose={true}
      >
        <div>
          <ListingAction assetId={assetId} />
        </div>
      </Modal>

      <div className="tab_assets_block">
        <Button
          onClick={() => onSubmitTab(1)}
          className={`tab_assets ${activeTab === 1 ? "active" : ""}`}
        >
          Real Volume
        </Button>
        <Button
          onClick={() => onSubmitTab(2)}
          className={`tab_assets ${activeTab === 2 ? "active" : ""}`}
        >
          Market Cap
        </Button>
        <Button
          onClick={() => onSubmitTab(3)}
          className={`tab_assets ${activeTab === 3 ? "active" : ""}`}
        >
          Holders Concentration
        </Button>
        <Button
          onClick={() => onSubmitTab(4)}
          className={`tab_assets ${activeTab === 4 ? "active" : ""}`}
        >
          Maturity
        </Button>
        <Button
          onClick={() => onSubmitTab(5)}
          className={`tab_assets ${activeTab === 5 ? "active" : ""}`}
        >
          Security
        </Button>
        <Button
          onClick={() => onSubmitTab(7)}
          className={`tab_assets ${activeTab === 7 ? "active" : ""}`}
        >
          Regulation
        </Button>
        <Button
          onClick={() => onSubmitTab(6)}
          className={`tab_assets ${activeTab === 6 ? "active" : ""}`}
        >
          General
        </Button>
      </div>
      {activeTab === 0 && (
        <AssetsLists setOpen={setOpen} setAssetId={setAssetId} />
      )}

      {activeTab === 1 && (
        <RealVolume setOpen={setOpen} setAssetId={setAssetId} />
      )}
      {activeTab === 2 && <span> Content of Tab Pane 2</span>}
      {/* {activeTab === 2 && <MarketCap />} */}
      {activeTab === 3 && <HoldersConcentration />}
      {activeTab === 4 && <Maturity />}
      {activeTab === 5 && <Security />}
      {activeTab === 7 && <Regulation />}
      {activeTab === 6 && <General />}
    </div>
  );
};
